import { Component, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Model, ModelService } from '../../core/services/model.service';
import { SpotComponent } from '../shared/spot/spot.component';
import { RevealDirective } from '../shared/reveal.directive';
import {DiscordIconComponent} from '../shared/discord-icon/discord-icon.component';

interface ContextSize {
  tokens: number;
  words: number;
  pages: number;
}

// Rough conversions for English prose.
const WORDS_PER_TOKEN = 0.75;
const WORDS_PER_PAGE = 250;

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [DecimalPipe, SpotComponent, RevealDirective, DiscordIconComponent]
})
export class AboutComponent implements OnInit {

  models: Model[] = [];

  constructor(
    private modelService: ModelService
  ) {}

  ngOnInit() {

    this.models = this.modelService.getModels();
  }

  /**
   * The smallest context window across the offered models, from the live model catalog.
   * Null until every model's context window has loaded, so the page never states a guess.
   */
  get smallestContext(): ContextSize | null {
    if (this.models.length === 0 || this.models.some(model => !model.contextWindow)) {
      return null;
    }
    const tokens = Math.min(...this.models.map(model => model.contextWindow as number));
    const words = Math.round(tokens * WORDS_PER_TOKEN / 1000) * 1000;
    return { tokens, words, pages: Math.round(words / WORDS_PER_PAGE) };
  }
}
